module.exports = __webpack_public_path__ + "img/php.2c8cc4a6.svg";